import { Flex, FlexProps } from '@chakra-ui/react'
import { HeroIconProps, MapPinIcon, Text, TextProps } from 'components'
import { Location } from 'types'

interface Props {
  location?: Location
  containerProps?: FlexProps
  textProps?: TextProps
  iconProps?: HeroIconProps
}

export default function LocationDisplay({ location, containerProps, textProps, iconProps }: Props) {
  return (
    <Flex alignItems="center" gap={1} {...containerProps}>
      <MapPinIcon fontSize="sm" {...iconProps} />
      <Text textStyle="bodyXSmall" truncate textOverflow="ellipsis" {...textProps}>
        {location ? `${location.city}, ${location.state || location.country}` : '--'}
      </Text>
    </Flex>
  )
}
